import Vue              from 'vue'
import store            from './store'
import notLoggedApp     from './Not_Logged_App'
import adminApp         from './Admin_App'
import customerApp      from './Customer_App'
import dispatcherApp    from './Dispatcher_App'
import notLoggedRouter  from './router/not_logged'
import adminRouter      from './router/admin'
import customerRouter   from './router/customer'
import dispatcherRouter from './router/dispatcher'
import vuetify          from '@/plugins/vuetify'

Vue.config.productionTip = false

Vue.filter('timeAgo', function (value) {
  return value
});

/* eslint-disable no-new */
var perfil = localStorage.getItem('perfil')
var token  = localStorage.getItem('token')
console.log('token', token)
console.log('perfil', perfil)
if (token) {
  if (perfil) {
    if (perfil === 'usuario-contrato' || perfil === 'usuario') {
      new Vue({
        el: '#app',
        router: customerRouter,
        vuetify,
        store,
        template: '<customerApp/>',
        components: { customerApp }
      })
    } else if (perfil === 'dispatcher' || perfil === 'recepcion' || perfil === 'supervisor' || perfil === 'tecnico taller') {
      new Vue({
        el    : '#app',
        router: dispatcherRouter,
        vuetify,
        store,
        template  : '<dispatcherApp/>',
        components: { dispatcherApp }
      })
    } else if (perfil === 'sistemas') {
      new Vue({
        el: '#app',
        vuetify,
        store,
        router    : adminRouter,
        template  : '<adminApp/>',
        components: { adminApp }
      })
    } else {
      new Vue({
        el: '#app',
        vuetify,
        store,
        router    : notLoggedRouter,
        template  : '<notLoggedApp/>',
        components: { notLoggedApp }
      })
    }
  } else {
    new Vue({
      el: '#app',
      vuetify,
      store,
      router    : notLoggedRouter,
      template  : '<notLoggedApp/>',
      components: { notLoggedApp }
    })
  }
} else {
  new Vue({
    el: '#app',
    vuetify,
    store,
    router    : notLoggedRouter,
    template  : '<notLoggedApp/>',
    components: { notLoggedApp }
  })
}



// WEBPACK FOOTER //
// ./src/main.js